import { schema as normalizrSchema } from "normalizr";

export const timerSchema = new normalizrSchema.Entity(
  "dealTimer",
  {},
  { idAttribute: (entity) => entity.alias }
);
export const arrayOfTimerSchemas = new normalizrSchema.Array(timerSchema);
